import { render, staticRenderFns } from "./JcomPlanEdit.vue?vue&type=template&id=520451e6"
import script from "./JcomPlanEdit.vue?vue&type=script&lang=js"
export * from "./JcomPlanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports